import { lazy } from 'react';
import { RoleBasedGuard } from 'src/auth/guard';
import { ROLES } from 'src/constants';

// ----------------------------------------------------------------------

const HomeEdRenewalListPage = lazy(() => import('src/pages/home-ed-renewal/list'));
const HomeEdRenewalAdminEditPage = lazy(() => import('src/pages/home-ed-renewal/edit'));
const HomeEdRenewalStartPage = lazy(() => import('src/pages/home-ed-renewal/start'));
const HomeEdRenewalFormPage = lazy(() => import('src/pages/home-ed-renewal/form'));
const HomeEdRenewalConfirmationPage = lazy(() => import('src/pages/home-ed-renewal/confirmation'));

// ----------------------------------------------------------------------

const guardedListPage = (
  <RoleBasedGuard navigateTo roles={[ROLES.HOMESCHOOL_FACILITATOR, ROLES.HOMESCHOOL_ADMIN]}>
    <HomeEdRenewalListPage />
  </RoleBasedGuard>
);

const guardedAdminEditPage = (
  <RoleBasedGuard navigateTo roles={[ROLES.HOMESCHOOL_FACILITATOR, ROLES.HOMESCHOOL_ADMIN]}>
    <HomeEdRenewalAdminEditPage />
  </RoleBasedGuard>
);

const guardedFormPage = (
  <RoleBasedGuard navigateTo roles={['User.User']}>
    <HomeEdRenewalFormPage />
  </RoleBasedGuard>
);

const guardedStartPage = (
  <RoleBasedGuard navigateTo roles={['User.User']}>
    <HomeEdRenewalStartPage />
  </RoleBasedGuard>
);

const guardedConfirmation = (
  <RoleBasedGuard navigateTo roles={['User.User']}>
    <HomeEdRenewalConfirmationPage />
  </RoleBasedGuard>
);

export const homeEdRenewalRoutes = [
  {
    path: 'home-ed-renewal',
    children: [
      { element: guardedListPage, index: true },
      {
        path: ':renewalId',
        children: [
          { element: guardedAdminEditPage, index: true },
          { path: 'start', element: guardedStartPage },
          { path: 'form', element: guardedFormPage },
          { path: 'confirmation', element: guardedConfirmation },
        ],
      },
    ],
  },
];
